import React from 'react';

const ErrorMessage : React.SFC<any> = (props) => {
    if(props.hidden === true) {
        return null;
    }

    return (<div style={{...props.style, ...{ width: '100%', backgroundColor: '#cc0000', padding: '0.5rem', borderRadius:'0.25rem', fontSize: '1.25rem', color: 'white' }}}>
        {props.children}
    </div>)
}

export default ErrorMessage